module.exports = __webpack_public_path__ + "static/nodejs-f434bfbbffc44588572e13e1e113391a.svg";